const FILES_KEY = 'ybit-offline-files-v1';

const loadFiles = () => {
  if (typeof window === 'undefined') return {};
  try {
    return JSON.parse(window.localStorage.getItem(FILES_KEY) || '{}');
  } catch (error) {
    console.warn('Could not read offline files.', error);
    return {};
  }
};

const saveFiles = (files) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(FILES_KEY, JSON.stringify(files));
};

const readFileAsDataUrl = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
  reader.readAsDataURL(file);
});

export const getStorage = () => ({ offline: true });

export const ref = (storage, path) => ({
  storage,
  fullPath: String(path).replace(/^\/+/, '')
});

export const uploadBytes = async (storageRef, file) => {
  const files = loadFiles();
  const dataUrl = await readFileAsDataUrl(file);
  files[storageRef.fullPath] = {
    dataUrl,
    name: file.name,
    type: file.type,
    updatedAt: new Date().toISOString()
  };
  saveFiles(files);

  return {
    ref: storageRef,
    metadata: {
      fullPath: storageRef.fullPath,
      contentType: file.type,
      name: file.name
    }
  };
};

export const getDownloadURL = async (storageRef) => {
  const files = loadFiles();
  return files[storageRef.fullPath]?.dataUrl || `/offline-files/${encodeURIComponent(storageRef.fullPath)}`;
};

export const __getOfflineFile = (path) => {
  const files = loadFiles();
  const normalized = String(path).replace(/^\/?offline-files\//, '');
  const decoded = decodeURIComponent(normalized);
  return files[decoded] || files[normalized] || null;
};

export const __saveOfflineFile = async (path, file) => {
  const files = loadFiles();
  const dataUrl = await readFileAsDataUrl(file);
  const normalized = String(path).replace(/^\/+/, '');
  files[normalized] = {
    dataUrl,
    name: file.name,
    type: file.type,
    updatedAt: new Date().toISOString()
  };
  saveFiles(files);
  return files[normalized];
};

